<template>
  <component :is="tag" v-html="richText"/>
</template>

<script>
import './RichText.scss'

export default {
  name: 'RichText',

  props: {
    tag: {
      type: String,
      required: false,
      default: "span"
    },
    richText: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>
